import React from 'react'

import Select from 'Components/Select'
import Traduction from 'Components/Traduction'
import Constants from 'EurestoFonction/Constants'
import Grid from '@material-ui/core/Grid'
import Title from 'Components/Title'

export default class ComboMultiSaisieLibre extends React.Component {
  constructor (props) {
    super(props)
  }

  render () {
    return (
      <Title inline={this.props.inline} style={{padding: '5px 0'}} title={this.props.title} buttons={(this.props.comboMultipleOption(this.props.options)).length > 0 && !this.props.disabled &&
      <button type="button" onClick={this.props.onClickAddComboMultiSaisieLibre} className="text-success ei-commun_ajouter"
              style={{marginLeft: 5}}/>}>
        {
          (this.props.data !== undefined ? this.props.data : []).map((data, index) => (
            <Grid container key={data.id + '_' + index} style={{margin: 0, padding: 0}} spacing={0} justify={'center'}
                  alignItems={'center'}>
              {!this.props.disabled && <Grid item style={{margin: 0, padding: 0,}}>
                <button type="button" onClick={() => this.props.onClickRemoveComboMultiSaisieLibre(index)}
                        className="text-danger ei-commun_enlever"/>
              </Grid>}
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Select inputStyle={this.props.style}
                  disabled={this.props.disabled || false}
                  options={this.props.comboMultipleOption(this.props.options, data.id)}
                  onChange={this.props.onChangeComboMultiSaisieLibre}
                  name={index}
                  value={data.id}/>
              </Grid>
              <Grid item xs style={{margin: 0, padding: 0}}>
                <Traduction
                  onChange={(e) => this.props.onChangeSecondComboMultiSaisieLibre(e, index)}
                  name={'valeur_text'}
                  disabled={this.props.disabled || false}
                  data={data.valeur_text !== undefined ? data.valeur_text : []}
                  type={Constants.typeSaisie.SaisieLibre}
                />
              </Grid>
            </Grid>
          ))
        }
      </Title>
    )
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Utilitaire/ComboMulti/ComboMultiSaisieLibre.js